"use client";
import { useTranslation } from "@/lib/i18n";
import { TResume } from "@/lib/store/resume";
import { formatPostalCodeWithPadding } from "@/utils";
import classNames from "classnames";
import { ReactNode } from "react";
import { TemplateProps } from ".";
import { Picture } from "../sidebars/left/sections/shared/Picture";

const TDCellContent = (props: {
  label: ReactNode | string;
  value?: string;
  valueClassNames?: string;
}) => {
  const { label, value, valueClassNames } = props;
  return (
    <div className="relative flex h-full w-full flex-col  items-center">
      <div className="mb-[20px] h-[14px] w-full text-sm">{label}</div>
      <div
        className={classNames(
          "flex items-start overflow-hidden text-sm",
          valueClassNames,
        )}
      >
        {value}
      </div>
    </div>
  );
};

const Header = ({ resume }: { resume: TResume }) => {
  const { t } = useTranslation({ ns: "resume-sidebar" });

  const basics = resume.data.basics;

  if (!basics) return null;

  return (
    <div className="relative w-full">
      <div className="mb-2 flex w-[440px] items-end justify-between">
        <p className="space-x-4 text-3xl">
          <span>履</span>
          <span>歴</span>
          <span>書</span>
        </p>
        <p className="text-base">{basics.creationDate}</p>
      </div>
      <table
        className="w-full table-fixed "
        style={{
          borderLeft: "2px solid black",
          borderBottom: "2px solid black",
        }}
      >
        <tbody>
          <tr>
            <td className="h-[10px] w-[450px] border-r-2 border-t-2 border-black text-sm">
              <div className="relative flex h-full items-center">
                <div className="relative flex h-full items-center">
                  <span className="block h-full w-[80px]">ふりがな</span>
                  <span className="block h-full w-[360px] overflow-hidden whitespace-nowrap text-center">
                    {basics.furigana}
                  </span>
                </div>
              </div>
            </td>
            <td className="w-[40px] !border-none"></td>
            <td className="!border-none"></td>
          </tr>
          <tr>
            <td
              className="h-[80px] w-[450px]"
              style={{
                borderRight: "2px solid black",
              }}
            >
              <div className="relative flex h-[80px] w-full items-center">
                <div className="flex h-[80px] w-[40px] items-start text-sm">
                  氏 名
                </div>
                <div className="flex h-[80px] flex-1 items-center justify-center overflow-hidden !text-2xl font-semibold">
                  {basics.name}
                </div>
              </div>
            </td>
            <td className="!border-none"></td>
            <td className="!border-none"></td>
          </tr>
          <tr>
            <td className="h-[30px] border-2 border-black !p-0 text-center text-lg">
              <div className="flex h-[20px] items-center justify-end overflow-hidden whitespace-nowrap text-sm">
                {basics.birthdate}
              </div>
            </td>
            <td
              colSpan={2}
              className="h-[30px] w-full text-sm"
              style={{
                borderTop: "2px solid black",
                borderRight: "2px solid black",
              }}
            >
              <div className="relative flex h-[20px] w-full flex-1 items-center justify-center">
                <div className="absolute left-0 top-0 w-[60xp] text-sm">
                  ※性别
                </div>
                <div className="flex items-center text-sm">{basics.gender}</div>
              </div>
            </td>
            {/* <td className="!border-none"></td> */}
          </tr>
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td
              colSpan={2}
              className="h-[10px] w-full text-sm"
              style={{
                borderTop: "2px solid black",
              }}
            >
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[60px]">ふりがな</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.locationFurigana}
                </span>
              </div>
            </td>
            <td
              colSpan={1}
              className="h-[10px] w-full text-sm"
              style={{
                borderTop: "2px solid black",
              }}
            >
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[60px] ">電話</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.phone}
                </span>
              </div>
            </td>
          </tr>
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td colSpan={2} className="h-[70px] w-full border-b-2 border-black">
              <TDCellContent
                label={
                  <div className="flex items-center justify-between text-sm">
                    <div className="space-x-7">
                      <span>現住所</span>
                      <span>
                        〒 {formatPostalCodeWithPadding(basics.postalCode)}
                      </span>
                    </div>
                  </div>
                }
                value={basics.location}
                valueClassNames="h-[44px]"
              />
            </td>
            <td colSpan={1} className="h-[70px] ">
              <TDCellContent
                label="Email"
                value={basics.email}
                valueClassNames="h-[44px]"
              />
            </td>
          </tr>
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td colSpan={2} className="h-[10px] w-full text-sm">
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[80px]">ふりがな</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.contactLocationFurigana}
                </span>
              </div>
            </td>
            <td
              colSpan={1}
              className="h-[10px] w-full text-sm"
              style={{
                borderTop: "2px solid black",
              }}
            >
              <div className="relative flex h-full items-center">
                <span className="block h-full w-[60px] ">電話</span>
                <span className="block h-full flex-1 overflow-hidden whitespace-nowrap text-center">
                  {basics.phone}
                </span>
              </div>
            </td>
          </tr>
          <tr
            style={{
              borderRight: "2px solid black",
            }}
          >
            <td colSpan={2} className="h-[70px] w-full">
              <TDCellContent
                label={
                  <div className="flex items-center justify-between text-sm">
                    <div className="space-x-7">
                      <span>連絡先</span>
                      <span>
                        〒{" "}
                        {formatPostalCodeWithPadding(
                          basics.contactLocationPostalCode,
                        )}
                      </span>
                    </div>
                    <span>(現住所以外に連絡を希望する場合のみ入力)</span>
                  </div>
                }
                value={basics.contactLocation}
                valueClassNames="h-[44px]"
              />
            </td>
            <td colSpan={1} className="h-[70px] ">
              <TDCellContent
                label="Email"
                value={basics.email}
                valueClassNames="h-[44px]"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <Picture
        resume={resume}
        className="!absolute right-[72px] top-[-10px] h-[168px] w-[120px]"
      />
    </div>
  );
};

const EducationAndExperience1 = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.educationAndExperience;
  const items = section?.items || [];
  return (
    <div className="!mb-[96px]">
      <table className="w-full table-fixed border-2 border-black">
        <tbody>
          <tr className="h-[26px]">
            <td className="text-md w-[100px] border-b-2 border-black py-0 text-center">
              年
            </td>
            <td className="text-md w-[40px] border-b-2 border-black py-0 text-center">
              月
            </td>
            <td className="text-md border-2 border-black py-0 text-center">
              学歴・職歴（各別にまとめて書く）
            </td>
          </tr>
          {Array(15)
            .fill("")
            .map((_, i) => i)
            .map((res, i) => {
              return (
                <tr key={res} className="h-[34px]">
                  <td className="text-md w-[60px] overflow-hidden whitespace-nowrap border-b-2 border-black text-center">
                    {items[res]?.year || ""}
                  </td>
                  <td className=" text-md w-[40px] overflow-hidden whitespace-nowrap border-b-2 border-black text-center">
                    {items[res]?.month || ""}
                  </td>
                  <td className=" text-md overflow-hidden whitespace-nowrap border-2 border-black text-center">
                    {items[res]?.summary || ""}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      <span className="text-xs font-light">
        ※「性別」欄：記載は任意です。未記載とすることも可能です。
      </span>
    </div>
  );
};

const EducationAndExperience2 = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.educationAndExperience;
  const items = section?.items || [];
  const certificationsSection = resume.data.sections?.certifications;
  const certificationsItems = certificationsSection?.items || [];
  return (
    <table className="w-full table-fixed border-2 border-black">
      <tbody>
        <tr className="h-[26px]">
          <td className="text-md w-[100px] border-b-2 border-black py-0 text-center">
            年
          </td>
          <td className="text-md w-[40px] border-b-2 border-black py-0 text-center">
            月
          </td>
          <td className="text-md border-2 border-black py-0 text-center">
            学歴 · 職歴
          </td>
        </tr>
        {Array(7)
          .fill("")
          .map((_, i) => i + 15)
          .map((res, i) => {
            return (
              <tr key={res} className="h-[34px]">
                <td className="text-md w-[60px] overflow-hidden whitespace-nowrap border-b-2 border-black text-center">
                  {items[res]?.year || ""}
                </td>
                <td className=" text-md w-[40px] overflow-hidden whitespace-nowrap border-b-2 border-black text-center">
                  {items[res]?.month || ""}
                </td>
                <td className=" text-md overflow-hidden whitespace-nowrap border-2 border-black text-center">
                  {items[res]?.summary || ""}
                </td>
              </tr>
            );
          })}
        <tr className="h-[26px]">
          <td className="text-md w-[100px] border-b-2 border-black py-0 text-center">
            年
          </td>
          <td className="text-md w-[40px] border-b-2 border-black py-0 text-center">
            月
          </td>
          <td className="text-md border-2 border-black py-0 text-center">
            免許・資格
          </td>
        </tr>
        {Array(6)
          .fill("")
          .map((_, i) => i)
          .map((res, i) => {
            return (
              <tr key={res} className="h-[34px]">
                <td className=" text-md w-[60px] overflow-hidden whitespace-nowrap border-b-2 border-black text-center">
                  {certificationsItems[res]?.year || ""}
                </td>
                <td className=" text-md w-[40px] overflow-hidden whitespace-nowrap border-b-2 border-black text-center">
                  {certificationsItems[res]?.month || ""}
                </td>
                <td className=" text-md overflow-hidden whitespace-nowrap border-2 border-black text-center">
                  {certificationsItems[res]?.summary || ""}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

// const Certifications = ({ resume }: { resume: TResume }) => {
//   const section = resume.data.sections?.certifications;
//   const items = section?.items || [];
//   return (
//     <table
//       className="w-full table-fixed"
//       style={{
//         border: "2px solid black",
//       }}
//     >
//       <tbody>
//         <tr className="h-[26px]">
//           <td className="text-md w-[100px] py-0 text-center">年</td>
//           <td className="text-md w-[40px] py-0 text-center">月</td>
//           <td className="text-md py-0 text-center">免許・資格</td>
//         </tr>
//         {Array(6)
//           .fill("")
//           .map((_, i) => i)
//           .map((res, i) => {
//             return (
//               <tr key={i} className="h-[34px]">
//                 <td className=" text-md w-[60px] overflow-hidden whitespace-nowrap text-center">
//                   {items[res]?.year || ""}
//                 </td>
//                 <td className=" text-md w-[40px] overflow-hidden whitespace-nowrap text-center">
//                   {items[res]?.month || ""}
//                 </td>
//                 <td className=" text-md overflow-hidden whitespace-nowrap text-center">
//                   {items[res]?.summary || ""}
//                 </td>
//               </tr>
//             );
//           })}
//       </tbody>
//     </table>
//   );
// };

const AmbitionMotive = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.ambitionMotive;

  return (
    <div className="h-[250px] w-full border-2 border-black">
      <div className="text-md mb-1 border-b-2  border-black p-1">
        志望動機・特技・アピールポイントなど
      </div>
      <div
        className="h-[210px] overflow-hidden p-1 text-base"
        dangerouslySetInnerHTML={{ __html: section?.content || "" }}
      />
    </div>
  );
};

const Expectations = ({ resume }: { resume: TResume }) => {
  const section = resume.data.sections?.expectations;
  return (
    <div className="h-[250px] w-full border-2 border-black">
      <div className="text-md mb-1 border-b-2  border-black p-1">
        本人希望欄（特に給料・職種・勤務時間・勤務地・その他について希望があれは記入）
      </div>
      <div
        className="h-[210px] overflow-hidden p-1 text-base"
        dangerouslySetInnerHTML={{ __html: section?.content || "" }}
      />
    </div>
  );
};

export const JIS002 = ({ resume, columns }: TemplateProps) => {
  return (
    <div className="space-y-4 p-[38px]">
      <Header resume={resume} />
      <EducationAndExperience1 resume={resume} />
      <EducationAndExperience2 resume={resume} />
      <AmbitionMotive resume={resume} />
      <Expectations resume={resume} />
    </div>
  );
};
